import React from "react";
import {Field} from "redux-form";
import MultipleSelect from "../MultipleSelect";

const options = [
    {_id: 'active', name: 'Aktiv'},
    {_id: 'inactive', name: 'Inaktiv'},
];
const UserStatusSelect = (props) => {

    return  <Field
        format={value => Array.isArray(value) ? value : []}
        name={props.fieldName}
        component={MultipleSelect}
        label={'Status'}
        fullWidth
        accessorValue={"_id"}
        accessorLabel={'name'}
        options={options}
    />;
};

export default UserStatusSelect;